import { add, qsa } from "@fluorescent/dom";
import {
  ImageReveal,
  FadeUpReveal,
  FadeUpSplitReveal,
  intersectionWatcher,
  shouldAnimate,
} from "@/lib/animation";

const selectors = {
  images: ".shoppable-feature__image, .shoppable-image__image",
  fadeUp: ".animation-fade-up-reveal",
  fadeUpSplit: ".animation-fade-up-split-reveal",
};

const classes = {
  revealed: "revealed",
};

export default node => {
  let observer = null;

  const fadeUpSplitItems = qsa(selectors.fadeUpSplit, node);
  const fadeUpItems = qsa(selectors.fadeUp, node);
  const images = qsa(selectors.images, node);
  const textReveals = [];
  const imageReveals = [];

  if (shouldAnimate(node)) {
    fadeUpSplitItems.forEach(item => {
      textReveals.push(new FadeUpSplitReveal(item));
    });

    fadeUpItems.forEach(item => {
      textReveals.push(new FadeUpReveal(item));
    });

    images.forEach(image => {
      imageReveals.push(new ImageReveal(image));
    });

    observer = intersectionWatcher(node, { cb: isVisible });
  }

  function isVisible() {
    let totalDelay = 0;
    let textDelay = 0;
    textReveals.forEach(reveal => {
      reveal.play(textDelay);

      if (reveal.type === "FadeUpSplitReveal") {
        textDelay += reveal.lineCount * window.theme.animation.delay;
      } else {
        textDelay += window.theme.animation.delay;
      }

      totalDelay += textDelay;
    });

    let imageDelay = 0;
    imageReveals.reverse().forEach((reveal, i) => {
      imageDelay = window.theme.animation.delayLong * i;
      reveal.play(imageDelay);

      totalDelay += imageDelay;
    });

    setTimeout(() => {
      add(node, classes.revealed);
    }, totalDelay * 1000);
  }

  return {
    destroy() {
      observer?.destroy();
    },
  };
};
